import { useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import SignupUserOrgForm from './SignupUserOrgForm';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';


export default function SignupUserOnboardForm({ setupUserMetadata, token }) {

	const [localState, setLocalState] = useState({
		inputSignupUserPassword: "",
		repeatPassword: "",
		showValidationError: false
	})
	const [showSetupOrgForm, setShowSetupOrgForm] = useState(false)

	const handleChange = (event) => {
		const value = event.target.value;
		setLocalState(prevState => ({
			...prevState,
			[event.target.name]: value,
			showValidationError: false
		}));
	}

	const submitSetNewPassword = () => {
		const { inputSignupUserPassword, repeatPassword } = localState;
		const sameInputs = ((inputSignupUserPassword && inputSignupUserPassword.length > 5) && (inputSignupUserPassword === repeatPassword)) ? true : false;

		if (sameInputs) {
			setShowSetupOrgForm(true)
		} else {
			setLocalState({ ...localState, showValidationError: true })
		}
	}


	const { showValidationError, inputSignupUserPassword } = localState;
	const { idToken: userIdToken, firstName } = setupUserMetadata || {}

	if (showSetupOrgForm) {
		return (
			<Box className="fade=in" bg='white' w='100%' p='3em 3em' rounded='0.25em' boxShadow={'xs'} m={[undefined, '3em auto']} maxW={['100%', '30em']}>
				<Box textAlign='center'>
					<Box fontSize='1.4em' fontWeight='600'>About your team </Box>
					<Box color='brandDark.500' fontSize='0.875em' py='1.2em'>And finally, let your audience know who you'd be representing</Box>
				</Box>

				<Box my='3%' mx='auto' maxW={['100%', '400px']} bg='white' p='1em' rounded='0.25em'>
					<SignupUserOrgForm 
						userSetPassword={inputSignupUserPassword} 
						userIdToken={userIdToken} 
						token={token} 
						/>
				</Box>
			</Box>

		)
	} else {
		return (
			<Flex direction='column' align='center' p='1em' mx='auto' w='100%' pt='1em' maxW='35em'>


				<Box className="fade=in" bg='white' w='100%' p='3em 3em' rounded='0.25em' boxShadow={'xs'} m={[undefined, '3em auto']} maxW={['100%', '30em']}>

					<Box textAlign='center' pb='1em' w='100%'>
						{firstName && <Box fontSize='1.4em' fontWeight='600'>Hey {firstName} </Box>}
						<Box color='brandDark.500' fontSize='1.2em'>Welcome to Launchdeck 👋</Box>
					</Box>
					<Box fontSize='0.875em' color='gray.700' textAlign='center' my='1.2em'>
						<Box>We'll help you set up in 2 quick steps.</Box>
						<Box>First, a secure password</Box>
					</Box>

					<Box mt='2em'>
						<LaunchdeckFormInput
							label='Password'
							name={'inputSignupUserPassword'}
							onChange={handleChange}
							value={localState.inputSignupUserPassword}
							isRequired={true}
							type='password'
						/>
					</Box>

					<Box mt='1em'>
						<LaunchdeckFormInput
							label='Confirm password'
							name={'repeatPassword'}
							onChange={handleChange}
							value={localState.repeatPassword}
							isRequired={true}
							type='password'

							errorLogic={showValidationError}
							errorMessage={`Your confirmation password did not match, or needs to be more than 6 characters`}
						/>
					</Box>

					<Flex direction='column' mt='3em' justify='center' alignItems='center'>
						<Flex justify='center' w='100%'>
							<LaunchdeckButton w='100%' bg='brand.500' color='white' onClick={() => submitSetNewPassword()} label='Set Password' />
						</Flex>
					</Flex>

				</Box>

			</Flex>

		)
	}

};